import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

// -- actions
import { CurrencyUtils } from 'PMT/utils';
import Notify from 'PMT/utils/Notify';

// -- entities
import MenuPartProduct from 'PMT/entities/menu/MenuPartProduct';
import Product from 'PMT/entities/menu/Product';

import SortableList from 'PMT/components/SortableList';

class MenuPartProductView extends Component {

  static propTypes = {
    product: PropTypes.instanceOf(Product).isRequired,

    menuManagedByPos: PropTypes.bool,

    menuPartProduct: PropTypes.instanceOf(MenuPartProduct).isRequired,

    onDelete: PropTypes.func.isRequired,

    onUpdate: PropTypes.func.isRequired,

    currencyCode: PropTypes.string,
  };

  get product(): Product {
    return this.props.product;
  }

  get currencyCode(): string {
    return this.props.currencyCode;
  }

  get menuPartProduct(): MenuPartProduct {
    return this.props.menuPartProduct;
  }

  onAdditionalPriceClicked = () => {
    if (this.props.menuManagedByPos) {
      return;
    }
    
    const menuPartProduct = this.menuPartProduct;
    Notify.promptWithValue(
      I18n.tr('menu.menu_edit.part.edit_addtionnal_price'),
      menuPartProduct.additionalPrice,
      (value) => {
        const floatValue = parseFloat(value);
        if (value && !_.isNaN(floatValue)) {
          menuPartProduct.additionalPrice = floatValue;
          this.props.onUpdate(menuPartProduct);
        }
      }
    );
  };

  render() {
    return (
      <div className="menu_part_product_view row">
        <div
          className="col-xs-7"
        >
          {this.product.name}
        </div>
        <div className="col-xs-2 pointer"
          onClick={this.onAdditionalPriceClicked}
        >
          {this.menuPartProduct.additionalPrice === 0 &&
            <span>-</span>
          }
          {this.menuPartProduct.additionalPrice !== 0 &&
            <span>
              +{CurrencyUtils.formatPriceWithCurrency(
                this.menuPartProduct.additionalPrice, this.currencyCode)}
            </span>
          }
        </div>

        {!this.props.menuManagedByPos &&
          <div
            className="text-center pointer col-xs-1"
            onClick={() => { this.props.onDelete(this.menuPartProduct); } }
          >
            <i className="fa fa-trash" />
          </div>
        }

        {!this.props.menuManagedByPos &&
          <div
            className="col-xs-1 text-center pointer"
            onClick={this.onAdditionalPriceClicked}
          >
            <i className="fa fa-edit" />
          </div>
        }

        {!this.props.menuManagedByPos &&
          <div className="col-xs-1">
            <SortableList.DragHandle />
          </div>
        }
      </div>
    );
  }

}

export default MenuPartProductView;
